import { useAuth } from "context/AuthContext";
import { useEffect, useState } from "react";
import ReactModal from "react-modal";

import { useModal } from "context/ModalContext";
import { Button } from "flowbite-react";

import "./styles.scss";

/**
 * Confirmação do resgate do prêmio especial. O card especial não entra no
 * resgate automático, então o empregado escolhe a hora de trocá-lo — e a troca
 * consome o card, que é justamente a graça de tê-lo guardado.
 *
 * Espera em `modalData`: `{ item, recompensa, onConfirm }`.
 */
export function ConfirmResgateModal() {
  const { user } = useAuth();
  const { openModal, modalData, closeModal } = useModal();

  const modalID = "modal-confirm-resgate";

  const [modalIsOpen, setIsOpen] = useState(false);

  ReactModal.setAppElement("#modal");

  useEffect(() => {
    if (!user) return;
    setIsOpen(openModal === modalID);
  }, [user, openModal, modalData]);

  if (!user) return null;

  if (!modalData?.item) return null;

  const { item, recompensa, onConfirm } = modalData;

  function handleConfirm() {
    onConfirm?.();
    closeModal();
  }

  return (
    <ReactModal
      shouldCloseOnOverlayClick={false}
      isOpen={modalIsOpen}
      onRequestClose={closeModal}
      contentLabel="Confirmar resgate do card especial"
      portalClassName="relative z-50"
      overlayClassName="fixed z-100 top-0 left-0 w-full h-full bg-gray-900 backdrop-blur-sm bg-opacity-90 flex flex-col items-center justify-center"
      contentElement={() => (
        <div id="modalConfirmResgate">
          <div className="bg-white p-6 rounded-xl flex flex-col items-center flex-none mx-5">
            <Button className="btnClose" type="button" onClick={closeModal}>
              X
            </Button>

            <span className="selo">Card Especial</span>

            <h3>Resgatar {item.name}?</h3>

            <img
              src={item.image?.medium?.url}
              alt={item.name}
              className="artCard"
            />

            {recompensa && (
              <p className="recompensa">
                Você vai receber <strong>{recompensa}</strong>.
              </p>
            )}

            <p className="aviso">
              O card especial sai da sua coleção quando você resgata. Enquanto
              não resgatar, ele continua na vitrine.
            </p>

            <div className="acoes">
              <button className="btnConfirmar" onClick={handleConfirm}>
                RESGATAR AGORA
              </button>
              <button className="btnCancelar" onClick={closeModal}>
                Agora não
              </button>
            </div>
          </div>
        </div>
      )}
    />
  );
}
